import { httpGet } from 'utils';
import { FilterConfigType } from '../types';
import { getfilters } from '../helpers';

interface IFetchActiveMarketsFiltersResponse {
  data: Record<string, string>[];
  count?: number;
}

interface IFetchActiveMarketsFilters {
  page?: number;
  pageSize?: number;
  searchText?: string;
  queryStr?: string;
  marketOpportunityType?: string;
  [key: string]: string | number | undefined;
}

export const fetchActiveMarketsFilters = (params?: IFetchActiveMarketsFilters, filterConfig?: FilterConfigType) => {
  const path = `portal/PortalActiveMarketsFilters`;
  const filterParams = getfilters(filterConfig);
  return httpGet<IFetchActiveMarketsFiltersResponse, IFetchActiveMarketsFilters>(
    path,
    {
      ...filterParams,
      ...(params?.page ? { page: params?.page } : {}),
      ...(params?.pageSize ? { pageSize: params?.pageSize } : {}),
      ...(params?.queryStr ? { queryStr: params?.queryStr } : {}),
    },
    true,
  );
};
